/* Ardor Rigid Sign Designer: the quote (the price customers pay). Same file in the theme (assets/ardor-rigid-quote.js) and
 * in node (rigid/core/tools/rigidquote.js). Generated; do not edit by hand.
 * Rules (Oct 20, 2026): 1. coroplast that fits inside a yard sign size (either way round) is priced and sold as the
 * cheapest yard size that holds it (yard packs, H-stake line, grommet add-on line); 2. pickup is priced without shipping
 * (magnets and aluminum signs: one price, ship or pickup) and goes on the pickup-only price product; 3. an order never
 * costs more than a bigger size or a bigger quantity of the same sign in the same delivery mode. See README-QUOTE.md.
 */
(function (root) {
  'use strict';
  // whole-dollar price rungs: $1..$1000, then each = floor(previous x 1.005), 2048 rungs (the two hidden price products)
  var RUNGS = (function () { var r = [], i; for (i = 1; i <= 1000; i++) r.push(i); while (r.length < 2048) r.push(Math.floor(r[r.length - 1] * 1005 / 1000)); return r; })();
  var TOP = RUNGS[RUNGS.length - 1];
  var ONE_PRICE = { MAG: 1, ALS: 1 }; // ship or pickup: the shipped price
  function r2(n) { return Math.round(n * 100) / 100; }
  function cents(x) { return Math.round(x * 100 + 1e-7) / 100; }
  function rungAt(x) { var lo = 0, hi = RUNGS.length - 1; if (x > TOP) return -1; while (lo < hi) { var mid = (lo + hi) >> 1; if (RUNGS[mid] >= x - 1e-9) hi = mid; else lo = mid + 1; } return lo; }
  // dollars -> rung lines [{ rung, price, qty }], rounded UP; above the top rung: top-rung lines + a rest line
  function ladder(total) {
    total = r2(total); if (!(total > 0)) return [];
    if (total <= TOP) { var i = rungAt(total); return [{ rung: i, price: RUNGS[i], qty: 1 }]; }
    var n = Math.floor(total / TOP), rest = r2(total - n * TOP), out = [{ rung: RUNGS.length - 1, price: TOP, qty: n }];
    if (rest > 0) { var j = rungAt(rest); out.push({ rung: j, price: RUNGS[j], qty: 1 }); }
    return out;
  }
  function sum(lines) { return r2(lines.reduce(function (t, l) { return t + l.price * l.qty; }, 0)); }
  function nfmt(n) { var r = Math.round(n * 1000) / 1000; return String(r); }
  function sid(w, h) { return nfmt(w) + 'x' + nfmt(h); }
  function okey(o) { return Object.keys(o || {}).sort().map(function (k) { return k + '=' + o[k]; }).join('&'); }

  // cfg: { data: price data, rsPrice: function, yard: { sizes: ['12x18', ...], variants: [{ w, h, sides, pack, id, cents,
  // available }], stake: { id, cents, available } } | null, maxQty: { COR: 400, default: 200 } }
  function create(cfg) {
    var D = cfg.data, RS = cfg.rsPrice;
    var MAXQ = cfg.maxQty || {};
    function maxQ(mat) { return MAXQ[mat] || (mat === 'COR' ? 400 : (MAXQ['default'] || 200)); }
    var Y = cfg.yard || {}, YV = {}, YSIZES = [];
    (Y.sizes || []).forEach(function (s) { var m = /^(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)$/.exec(String(s)); if (m) YSIZES.push([+m[1], +m[2]]); });
    (Y.variants || []).forEach(function (v) {
      if (!v || !(v.cents > 0) || !(v.w > 0) || !(v.h > 0)) return;
      YV[sid(v.w, v.h) + '|' + v.sides + '|' + v.pack] = { id: v.id, cents: Math.round(v.cents), available: v.available !== false };
    });
    var YSTAKE = Y.stake && Y.stake.id && Y.stake.cents > 0 ? { id: Y.stake.id, cents: Math.round(Y.stake.cents), available: Y.stake.available !== false } : null;
    var memo = {}, memoN = 0;
    function remember(k, v) { if (memoN > 60000) { memo = {}; memoN = 0; } memoN++; memo[k] = v; return v; }

    function limits(mat) { var m = D.materials[mat]; return m || null; }
    function fitsShip(m, w, h) { var L = Math.max(w, h), S = Math.min(w, h); return L <= m.shipMax.long + 1e-9 && S <= m.shipMax.short + 1e-9; }
    function fitsAny(m, w, h) {
      if (fitsShip(m, w, h)) return true;
      var L = Math.max(w, h), S = Math.min(w, h);
      return (m.pickupMax || []).some(function (p) { return L <= p.long + 1e-9 && S <= p.short + 1e-9; });
    }
    // the raw price of one order (dollars, exact), or null: ship = rsPrice's price (shipped sizes only); pickup = the same
    // without shipping (any size up to the in-house maximum)
    function base(mat, w, h, o, q, mode, ok) {
      var k = 'b|' + mat + '|' + sid(w, h) + '|' + ok + '|' + mode + '|' + q;
      if (k in memo) return memo[k];
      var r = null; try { r = RS(D, mat, w, h, o, q); } catch (e) { r = null; }
      var v = null;
      if (r) v = mode === 'ship' ? (r.pickupOnly ? null : r.ours) : (r.pickupOnly ? r.ours : cents(2 * r.supplierSubtotal));
      return remember(k, v);
    }
    // the quantities above q where the coroplast unit price steps down (its price-break tables); every other
    // material has one unit price for every quantity and shipping that never drops with more pieces (checked on every
    // ship cell, 1-200 pieces), so a bigger quantity never costs less there
    function breaks(mat, w, h, o, q) {
      if (mat !== 'COR') return [];
      var sides = o.sides === '2' ? '2' : '1', out = [], F = D.corFine, add = function (n) { n = +n; if (n > q && out.indexOf(n) < 0) out.push(n); };
      add(2);
      if (F) {
        var Wi = Math.max(F.min, Math.ceil(w - 1e-9)), Hi = Math.max(F.min, Math.ceil(h - 1e-9)), ref = F.idx[Wi + 'x' + Hi];
        if (ref) { String(F.tables[ref[sides === '2' ? 1 : 0]] || '').split(',').forEach(function (e) { if (e) add(e.split(':')[0]); }); return out; }
      }
      var gw = D.corGrid.w, gh = D.corGrid.h, W = null, H = null, i;
      for (i = 0; i < gw.length; i++) if (gw[i] >= w - 1e-9) { W = gw[i]; break; }
      for (i = 0; i < gh.length; i++) if (gh[i] >= h - 1e-9) { H = gh[i]; break; }
      var pb = W && H && D.corPB[W + 'x' + H] ? D.corPB[W + 'x' + H][sides] : null;
      (pb || []).forEach(function (e) { add(e[0]); });
      return out;
    }
    // the lowest price of this size at q or more pieces: { v, q }
    function qtyMin(mat, w, h, o, q, mode, ok) {
      var k = 'q|' + mat + '|' + sid(w, h) + '|' + ok + '|' + mode + '|' + q;
      if (k in memo) return memo[k];
      var mq = maxQ(mat), best = { v: base(mat, w, h, o, q, mode, ok), q: q };
      breaks(mat, w, h, o, q).forEach(function (n) {
        if (n > mq) return;
        var v = base(mat, w, h, o, n, mode, ok);
        if (v != null && (best.v == null || v < best.v - 1e-9)) best = { v: v, q: n };
      });
      return remember(k, best);
    }
    // the bigger sizes to compare: the corners of the price / shipping grid that hold the sign, inside the
    // mode's size limit. Coroplast keeps its orientation (flutes); other boards may turn.
    function corners(mat, w, h, mode, o) {
      var m = D.materials[mat], out = [], i, j;
      if (mat === 'COR') {
        var g = D.corGrid.w.slice(); if (mode === 'pickup') (m.pickupMax || []).forEach(function (p) { [p.long, p.short].forEach(function (x) { if (g.indexOf(x) < 0) g.push(x); }); });
        g.sort(function (a, b) { return a - b; });
        for (i = 0; i < g.length; i++) {
          if (g[i] < w - 1e-9) continue;
          for (j = 0; j < g.length; j++) {
            if (g[j] < h - 1e-9) continue;
            if (Math.abs(g[i] - w) < 1e-9 && Math.abs(g[j] - h) < 1e-9) continue;
            var ship = fitsShip(m, g[i], g[j]);
            if (mode === 'ship' ? !ship : !fitsAny(m, g[i], g[j])) continue;
            if (!ship && o.hardware === '1') continue; // no H-stake on the in-house sheets
            out.push([g[i], g[j]]);
          }
        }
        return out;
      }
      if (mode === 'pickup') return out; // pickup boards: priced by area at one unit price, a bigger board never costs less
      var sg = D.ship[m.shipGroup]; if (!sg) return out;
      var L = Math.max(w, h), S = Math.min(w, h);
      for (i = 0; i < sg.gridL.length; i++) {
        var Lc = sg.gridL[i]; if (Lc < L - 1e-9) continue;
        for (j = 0; j < sg.gridS.length; j++) {
          var Sc = sg.gridS[j]; if (Sc < S - 1e-9 || Sc > Lc) continue;
          if (Math.abs(Lc - L) < 1e-9 && Math.abs(Sc - S) < 1e-9) continue;
          if (!fitsShip(m, Lc, Sc)) continue;
          out.push([Lc, Sc]);
        }
      }
      return out;
    }
    // rule 3: the lowest price of this sign at this size or bigger, this quantity or more (same material, options, mode)
    // -> { v (exact dollars), w, h, q (the order it was priced as), base (this order's own price) }
    // (corners only: the order's own size left out, for yard-priced signs: the bigger sizes that are not yard sizes)
    function low(mat, w, h, o, q, mode, cornersOnly) {
      var ok = okey(o), k = 'e|' + mat + '|' + sid(w, h) + '|' + ok + '|' + mode + '|' + q + '|' + (cornersOnly ? 'c' : '');
      if (k in memo) return memo[k];
      var b = base(mat, w, h, o, q, mode, ok), own = cornersOnly ? { v: null, q: q } : qtyMin(mat, w, h, o, q, mode, ok);
      var best = { v: own.v, w: w, h: h, q: own.q, base: b };
      corners(mat, w, h, mode, o).forEach(function (c) {
        if (cornersOnly && inYard(c[0], c[1])) return;
        var g = qtyMin(mat, c[0], c[1], o, q, mode, ok);
        if (g.v != null && (best.v == null || g.v < best.v - 1e-9)) best = { v: g.v, w: c[0], h: c[1], q: g.q, base: b };
      });
      return remember(k, best);
    }

    // rule 1: the cheapest yard sign size that holds a w x h coroplast sign (either way round), for these sides and pack
    function fits(Yw, Yh, w, h) { return (w <= Yw + 1e-9 && h <= Yh + 1e-9) || (h <= Yw + 1e-9 && w <= Yh + 1e-9); }
    function inYard(w, h) { return YSIZES.some(function (s) { return fits(s[0], s[1], w, h); }); }
    function yardCap(w, h, sides, pack) {
      var best = null;
      YSIZES.forEach(function (s) {
        if (!fits(s[0], s[1], w, h)) return;
        var v = YV[sid(s[0], s[1]) + '|' + sides + '|' + pack];
        if (!v) return;
        var same = w <= s[0] + 1e-9 && h <= s[1] + 1e-9;
        if (!best || v.cents < best.v.cents || (v.cents === best.v.cents && ((same && !best.same) || (same === best.same && s[0] * s[1] < best.w * best.h)))) best = { w: s[0], h: s[1], v: v, same: same };
      });
      return best;
    }
    function yardPacks(Yw, Yh, sides) {
      var out = []; Object.keys(YV).forEach(function (k) { var p = k.split('|'); if (p[0] === sid(Yw, Yh) && p[1] === String(sides)) out.push(+p[2]); });
      return out.sort(function (a, b) { return a - b; });
    }
    // the yard size and packs a coroplast sign would use (null: not a yard-priced sign)
    function cap(mat, w, h, sides, pack) {
      if (mat !== 'COR' || !YSIZES.length) return null;
      var m = D.materials.COR; if (!m || !fitsShip(m, w, h) || !inYard(w, h)) return null;
      var c = pack > 1 ? yardCap(w, h, sides, pack) : null, pk = pack;
      if (!c) { c = yardCap(w, h, sides, 1); pk = 1; }
      if (!c) return null;
      return { w: c.w, h: c.h, pack: pk, packs: yardPacks(c.w, c.h, sides), variant: c.v };
    }

    // req: { mat, w, h, opts (supplier option keys), qty (signs; packs when yard-priced), pack, delivery: 'ship'|'pickup' }
    // -> see README-QUOTE.md
    function quote(req) {
      var mat = req.mat, m = D.materials[mat], o = req.opts || {}, ok = okey(o);
      var w = +req.w, h = +req.h, qty = Math.max(1, Math.floor(+req.qty || 1)), pack = Math.max(1, Math.floor(+req.pack || 1));
      var res = { ok: false, reason: '', mat: mat, w: w, h: h, delivery: 'ship', mode: 'ship', ladder: 'shipped', kind: 'ladder', exact: 0, charged: 0, lines: [], signs: qty, qty: qty, pack: 1, yard: null, basis: null, base: 0 };
      if (!m) { res.reason = 'material'; return res; }
      if (!(w >= m.min.w - 1e-9 && h >= m.min.h - 1e-9) || !fitsAny(m, w, h)) { res.reason = 'size'; return res; }
      var shippable = fitsShip(m, w, h), pickup = !shippable || req.delivery === 'pickup';
      res.delivery = pickup ? 'pickup' : 'ship';
      var mode = pickup && !ONE_PRICE[mat] ? 'pickup' : 'ship';
      var sides = o.sides === '2' ? 2 : 1;
      var yc = cap(mat, w, h, sides, pack);
      if (yc) {
        // rule 1: the yard sign (packs), its H-stake line and grommets as a ladder line
        var signs = qty * yc.pack, yt = yc.variant.cents * qty / 100, ylines = [{ kind: 'yard', id: yc.variant.id, qty: qty, price: yc.variant.cents / 100, available: yc.variant.available }];
        if (o.hardware === '1') {
          if (!YSTAKE) { res.reason = 'price'; return res; }
          ylines.push({ kind: 'stake', id: YSTAKE.id, qty: signs, price: YSTAKE.cents / 100, available: YSTAKE.available }); yt += YSTAKE.cents * signs / 100;
        }
        var gch = (m.surcharges && m.surcharges.grommet || {})[o.grommet] || 0, gex = 0;
        if (gch) { gex = r2(2 * gch * signs); ladder(gex).forEach(function (l) { ylines.push({ kind: 'grommet', rung: l.rung, qty: l.qty, price: l.price, exact: gex, ladder: 'shipped' }); }); }
        var yex = r2(yt + gex), ych = sum(ylines);
        res.yard = { w: yc.w, h: yc.h, pack: yc.pack, packs: yc.packs, id: yc.variant.id, cents: yc.variant.cents };
        res.signs = signs; res.qty = qty; res.pack = yc.pack;
        // rule 3 against bigger coroplast sizes that are not yard sizes, at this many signs or more (shipped)
        var alt = signs <= maxQ(mat) ? low(mat, w, h, o, signs, 'ship', true) : { v: null }, altOk = alt.v != null;
        var shipRes = { kind: 'yard', exact: yex, charged: ych, lines: ylines, ladder: 'shipped', mode: 'ship', basis: { rule: 'yard', w: yc.w, h: yc.h } };
        if (altOk && sum(ladder(alt.v)) < ych - 0.004) shipRes = { kind: 'ladder', exact: alt.v, charged: sum(ladder(alt.v)), lines: ladder(alt.v).map(function (l) { return { kind: 'ladder', rung: l.rung, qty: l.qty, price: l.price, ladder: 'shipped' }; }), ladder: 'shipped', mode: 'ship', basis: { rule: 'bigger', w: alt.w, h: alt.h, q: alt.q } };
        var pick = shipRes;
        if (mode === 'pickup' && signs <= maxQ(mat)) {
          var pk = low(mat, w, h, o, signs, 'pickup');
          if (pk.v != null && sum(ladder(pk.v)) < shipRes.charged - 0.004) pick = { kind: 'ladder', exact: pk.v, charged: sum(ladder(pk.v)), lines: ladder(pk.v).map(function (l) { return { kind: 'ladder', rung: l.rung, qty: l.qty, price: l.price, ladder: 'pickup' }; }), ladder: 'pickup', mode: 'pickup', basis: pk.w !== w || pk.h !== h || pk.q !== signs ? { rule: 'bigger', w: pk.w, h: pk.h, q: pk.q } : { rule: 'own' } };
        }
        res.kind = pick.kind; res.exact = pick.exact; res.charged = pick.charged; res.lines = pick.lines; res.ladder = pick.ladder; res.mode = pick.mode; res.basis = pick.basis; res.base = yex;
        res.ok = true; return res;
      }
      if (qty > maxQ(mat)) { res.reason = 'qty'; return res; }
      var e = low(mat, w, h, o, qty, mode);
      if (e.v == null || !(e.v > 0)) { res.reason = 'price'; return res; }
      res.mode = mode; res.ladder = mode === 'pickup' ? 'pickup' : 'shipped';
      res.exact = e.v; res.base = e.base;
      res.lines = ladder(e.v).map(function (l) { return { kind: 'ladder', rung: l.rung, qty: l.qty, price: l.price, ladder: res.ladder }; });
      res.charged = sum(res.lines);
      res.basis = e.w !== w || e.h !== h || e.q !== qty ? { rule: 'bigger', w: e.w, h: e.h, q: e.q } : { rule: 'own' };
      res.ok = true; return res;
    }
    return { quote: quote, cap: cap, low: low, base: function (mat, w, h, o, q, mode) { return base(mat, w, h, o || {}, q, mode, okey(o || {})); }, ladder: ladder, rungs: RUNGS, onePrice: ONE_PRICE, clear: function () { memo = {}; memoN = 0; } };
  }

  var api = { v: 'rigidquote-1', create: create, ladder: ladder, rungs: RUNGS };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ArdorRigidQuote = api;
})(typeof window !== 'undefined' ? window : globalThis);
